<template>
  <div class="stripe">
    <label>{{ labels.cardInfo }}</label>
    <div class="stripe__card" ref="card" />
    <button
      class="stripe__button"
      @click.prevent="pay"
      :disabled="!clientSecret || inProgress"
    >
      {{ labels.pay }}
    </button>
    <div class="stripe__error" v-if="message">{{ message }}</div>
    <div v-show="inProgress" class="stripe__spinner" />
  </div>
</template>

<script>
import { loadStripe } from '@stripe/stripe-js/pure';
import axios from 'axios';

export default {
  name: 'stripe',

  props: {
    pk: {
      type: String,
      default: null,
    },
    labels: {
      type: Object,
      required: true,
    },
    amount: {
      type: Number,
      default: null,
    },
    name: {
      type: String,
      default: 'Donor',
    },
  },

  watch: {
    stripe(value, old) {
      if (value && old === null) {
        this.createElementsInstance();
        this.createCardInstance();
        this.createPaymentIntent();
      }
    },
    amount() {
      if (this.stripe && this.card) {
        this.createPaymentIntent();
      }
    },
  },

  data() {
    return {
      clientSecret: null,
      elements: null,
      stripe: null,
      card: null,
      message: null,
      style: {
        base: {
          color: '#32325d',
          fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
          fontSmoothing: 'antialiased',
          fontSize: '16px',
          '::placeholder': {
            color: '#aab7c4',
          },
        },
        invalid: {
          color: '#fa755a',
          iconColor: '#fa755a',
        },
      },
      inProgress: false,
    };
  },

  mounted() {
    loadStripe(this.pk).then((res) => {
      this.stripe = res;
    });
  },

  methods: {
    createElementsInstance() {
      this.elements = this.stripe.elements();
    },

    createCardInstance() {
      this.card = this.elements.create('card', {
        style: this.style,
        hidePostalCode: true,
      });
      this.card.mount(this.$refs.card);
    },

    createPaymentIntent() {
      if (this.amount === null) return false;
      this.inProgress = true;
      const data = {
        action: 'stripe_intent',
        nonce: this.$parent.wpNonce,
        amount: this.amount,
      };
      let formData = new FormData();
      for (let k in data) {
        if (data[k] !== null) {
          formData.append(k, data[k]);
        }
      }
      axios
        .post(this.$parent.wpAjax, formData)
        .then((response) => {
          this.clientSecret = response.data.intent;
          this.inProgress = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    pay() {
      this.inProgress = true;
      this.$emit('initiated');
      this.message = null;
      this.stripe
        .confirmCardPayment(this.clientSecret, {
          payment_method: {
            card: this.card,
            billing_details: {
              name: this.name,
            },
          },
        })
        .then((result) => {
          if (result.error) {
            this.message = result.error.message;
            this.$emit('completed', {
              status: 'error',
              reference: result.error.message,
            });
          } else {
            if (result.paymentIntent.status === 'succeeded') {
              this.$emit('completed', {
                status: 'Completed',
                reference: result.paymentIntent.id,
              });
            } else {
              this.$emit('completed', {
                status: result.paymentIntent.status,
                reference: result.paymentIntent.id,
              });
              this.message = result.paymentIntent.status;
            }
          }
        })
        .catch((err) => {
          this.$emit('completed', {
            status: 'error',
            reference: err,
          });
          this.message = this.labels.error;
        });
    },
  },
};
</script>
